import { render, staticRenderFns } from "./OrgAccount.vue?vue&type=template&id=e3174d66&scoped=true"
import script from "./OrgAccount.vue?vue&type=script&lang=js"
export * from "./OrgAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3174d66",
  null
  
)

export default component.exports